import { styled } from '@mui/material';

export const VerticalSeparator = styled('span')(({ theme }) => ({
    '&:before': {
        content: '"|"',
        margin: theme.spacing(1),
    },
}));
